import { checkTimeordate, isTimestring } from '../types'
import mtz from '../utils/mtz'

const makeAdd = (context = {}) => {
  const { timezone } = context

  const add = (timeordate, duration) => {
    checkTimeordate(timeordate)

    const { years, months, weeks, days, hours, minutes, seconds } = duration
    const mDate = mtz(timeordate, timezone)
    if (years) {
      mDate.add(years, 'years')
    }
    if (months) {
      mDate.add(months, 'months')
    }
    if (weeks) {
      mDate.add(weeks, 'weeks')
    }
    if (days) {
      mDate.add(days, 'days')
    }
    if (hours) {
      mDate.add(hours, 'hours')
    }
    if (minutes) {
      mDate.add(minutes, 'minutes')
    }
    if (seconds) {
      mDate.add(seconds, 'seconds')
    }

    return isTimestring(timeordate)
      ? mDate.toISOString()
      : mDate.format('Y-MM-DD')
  }

  return add
}

export default makeAdd
